import { ROUTES } from "@/routes/Routes";
import {
  requestSearchAlerts,
  requestUpdateAlertSeen,
} from "@/state/alerts/AlertEffects";
import { toastError } from "@/utils/helpers/toast-helper";
import BasicCard from "@components/core/cards/BasicCard";
import LinkButton from "@components/core/links/LinkButton";
import { AlertDetailResponseDto } from "@state/alerts/dto/response/alert.detail.response.dto";
import DeleteIcon from "@static/core/icons/icon-delete.svg?react";
import parse from "html-react-parser";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface InfoCardProps {
  background?: string;
  buttonLabel?: string;
  className?: string;
  color?: string;
  description?: string;
  list?: AlertDetailResponseDto[];
  title?: string;
  url?: string;
}

const InfoCard: FunctionComponent<InfoCardProps> = ({
  title,
  background,
  color,
  list,
  description,
  url,
  buttonLabel,
  className = "",
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const alertRedirection = (transactionId: string) => {
    navigate(ROUTES.extranet.transactions.details.generate(transactionId));
  };

  const alertSeen = (alertId: string) => {
    requestUpdateAlertSeen({ dto: true, id: alertId })
      .then((response) => {
        if (response.ok) {
          void requestSearchAlerts({});
        } else {
          toastError(t("error.alert.updateVu"));
        }
      })
      .catch(() => {
        toastError(t("error.alert.updateVu"));
      });
  };

  return (
    <BasicCard
      className={`app-info-card ${background ? `bg-${background}` : ""} ${
        color ? `text-${color}` : "text-font"
      } ${className}`}
    >
      <>
        <div className="card-header">
          {title && <h2 className="card-title">{title}</h2>}
        </div>
        <div className="card-body">
          {list && (
            <ul className="list">
              {list.map((item, index) => (
                <li className="list-item" key={index}>
                  <div
                    className="list-item-content"
                    onClick={() => alertRedirection(item.transactionId)}
                  >
                    {parse(item.content)}
                  </div>
                  <div
                    className="list-item-icon"
                    onClick={() => alertSeen(item.id)}
                  >
                    <DeleteIcon className="icon-delete" />
                  </div>
                </li>
              ))}
            </ul>
          )}
          {description && <p>{parse(description)} </p>}
          {url && <LinkButton to={url} text={buttonLabel} />}
        </div>
      </>
    </BasicCard>
  );
};

export default InfoCard;
